import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="import-workspace"
export default class extends Controller<HTMLElement> {
  static values = {
    activeAnchor: String
  };

  declare readonly activeAnchorValue: string;
  declare readonly hasActiveAnchorValue: boolean;

  connect() {
    if (!this.hasActiveAnchorValue || this.activeAnchorValue === "setup") return;
    if (window.location.hash) return;

    window.requestAnimationFrame(() => {
      document.getElementById(this.activeAnchorValue)?.scrollIntoView({ block: "start" });
    });
  }
}
